import mergeRecursive from '@/utils/mergeRecursive'

export const Company = {
  id: null,
  name: null,
  fantasy_name: null,
  document_number: null,
  url: null,
  phone: null,
  logo: null,
  address: {
    id: null,
    street: null,
    number: null,
    complement: null,
    neighborhood: null,
    city: null,
    province: null,
    country_id: null,
    zip_code: null
  },
  daily_limit_per_user: null,
  month_limit: null,
  is_business_partner: null,
  is_active: null,
  cashback: null
}

export const companyAssigned = (source) => {
  const target = mergeRecursive({ ...Company }, { ...source })
  target.address.country_id = source.address.country
  return target
}
